export default "__VITE_ASSET__95a3a505__"